// The skeleton knife: "sapphire doppler skeleton knife (CS2 reference)" by Mvlyy
// (sketchfab.com/Mvlyy, CC-BY-4.0), split by scripts/import-skeleton.mjs into the handle (with its wrap
// and ring) and the blade. Held like CS2's: the index finger just behind the ring, the blade forward; its
// inspect turns the wrist to stand the blade up and show its holes.

import * as THREE from 'three';
import { straightKnifeLoader } from './straightKnife';

export const loadSkeleton = straightKnifeLoader({
  url: `${import.meta.env.BASE_URL ?? '/'}assets/models/skeleton.glb`,
  colors: { handle: 0x111317 },
  fitScale: 0.1,
  // Just behind the ring (the ring is the handle's first 5.5 units from the blade side).
  index: { part: 'handle', from: 'bladeEnd', offset: 6 },
  fistLength: 26,
  edgeSide: 1,
  inspect: {
    fist: new THREE.Vector3(0.06, -0.08, -0.5),
    across: new THREE.Vector3(-0.2, -1, 0.05),
    knuckles: new THREE.Vector3(-0.2, 0.1, -0.95),
    palm: false,
  },
});
